module.exports = __webpack_public_path__ + "static/media/005.37eb6d02.jpg";